import { createElement, memo, useEffect, useCallback } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import './index.scss';
import { getImageUrl } from '../../../lib/utils/imageUtils';
const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
const FlightTheme2 = (props) => {
    // 初始化
    useEffect(() => {
        // TODO: 实现初始化逻辑
        // setEntryParams(getEntryParams(window.location.href));
        // getGetAPI();
    }, []);
    const formatterDay = useCallback((date, t) => {
        var y = date.substring(0, 4), m = date.substring(5, 2), d = date.substring(8, 2);
        if (t === 'time') {
            return new Date(Number(y), Number(m) - 1, Number(d)).getTime() / 1000; // 精确到秒
        }
        return y + '.' + m + '.' + d + ' ' + week[new Date(Number(y), Number(m) - 1, Number(d)).getDay()];
    }, []);
    return <View className="flight-theme-2">
      {props.data.map((item, index) => {
        return <View className="list" key={index}>
            <Image className='list-img' source={{
            uri: getImageUrl(item.picurl, 240, 0)
        }}/>
            <View className="discount">
              <Text x-if={item.discout > 0} className='discount-text'>{item.discout / 10}折</Text>
              <Text x-else className='discount-text'>限量</Text>
            </View>
            <View x-if={item.purchaserCount} className="purchaserCount">
              近1小时有{Number(props.purchaserCount ? props.purchaserCount : '') * ((item === null || item === void 0 ? void 0 : item.purchaserCount) || 0)}人想买
            </View>
            <View className="right">
              <View className="flight-city">{item.departCityName} - {item.arriveCityName}</View>
              <View className="flight-depart">出发：{formatterDay(item.date)}</View>
              <View x-if={props.routeConfig_recommendType === 4} className="flight-depart" style={{
            marginTop: '-8rpx'
        }}>
                航班号：{item.flightNumber}
              </View>
              <View x-if={props.routeConfig_recommendType !== 4} className="x-product-wrap">
                <Text x-if={item.ticketNumber} className="ticket">票少</Text>
                <Text x-if={!props.cornerLabelImg && props.cornerLabelWord} className="label-word" style={{
            backgroundColor: props.cornerLabelBgColor,
            color: props.cornerLabelColor
        }}>{props.cornerLabelWord}</Text>
                <Image x-if={props.cornerLabelImg} className="label-img" source={{
            uri: getImageUrl((props === null || props === void 0 ? void 0 : props.cornerLabelImg) || '', 66, 0)
        }}/>
              </View>
              <View className="price-wrap">
                <Text className="price-sym">￥</Text><Text className="price">{item.price}</Text>
                <Text className="person">/人</Text>
              </View>
              <View className="btn" onClick={() => props.jump(item, index)}>立即抢购</View>
            </View>
          </View>;
    })}
    </View>;
};
export default memo(FlightTheme2);
